import type { TableProps } from "@heroui/table";
import { cn } from "../../lib/utils";

type Classnames = TableProps["classNames"];
/**
 * Merges two classNames objects by combining classes for matching keys using the cn utility.
 * @param defaults - Default classNames object
 * @param overrides - Consumer-provided classNames to merge
 * @returns Merged classNames object
 */
export function mergeTableClassNames(defaults: Classnames, overrides?: Classnames): Classnames {
  if (!overrides) return defaults;

  const merged: Record<string, unknown> = { ...defaults };

  for (const key in overrides) {
    const defaultValue = defaults?.[key as keyof typeof defaults];
    const overrideValue = overrides[key as keyof typeof overrides];
    merged[key] = cn(defaultValue as string, overrideValue as string);
  }

  return merged as Classnames;
}
